var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.595,
    height: 20.863,
    viewBox: "0 0 16.595 20.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "next",
    transform: "translate(-9.405 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-icon",
    transform: "translate(9.405 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Last_Page"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_772",
    "data-name": "Caminho 772",
    d: "M26.379.35A1.037,1.037,0,0,0,24.9.35a1.058,1.058,0,0,0,0,1.488l8.551,8.633L24.9,19.1a1.058,1.058,0,0,0,0,1.488,1.037,1.037,0,0,0,1.476,0l9.287-9.377a1.018,1.018,0,0,0,.291-.821,1.089,1.089,0,0,0-.291-.668Z",
    transform: "translate(-24.597 -0.038)",
    fill: "#dbb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_773",
    "data-name": "Caminho 773",
    d: "M192.878,0a1.044,1.044,0,0,0-1.044,1.044V19.8a1.044,1.044,0,0,0,2.087,0V1.044A1.044,1.044,0,0,0,192.878,0Z",
    transform: "translate(-177.326)",
    fill: "#dbb200"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.cde8c32079c71ed3e5e97f0fe7898526.svg";
export { ForwardRef as ReactComponent };